"use strict";$(function(){//Do yo JAHVAHSCRIPT here.
//mobile nav controller
$('.mobile-nav-trigger').on('click',function(){$(this).toggleClass('active');$('nav.nav').toggleClass('mobile-menu-open');});autosize($('textarea'));});